import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { TimaticErrorsService } from '../services/timatic-errors.service';
import { TravelDocsErrors } from '../../interface/travel-docs.interface';

@Injectable({
  providedIn: 'root'
})
export class TimaticErrorsFacade {
  private readonly travelDocsErrorsSubject =
    new BehaviorSubject<TravelDocsErrors | null>(null);

  constructor(private timaticErrorsService: TimaticErrorsService) {}

  getTravelDocsErrors(): Observable<TravelDocsErrors | null> {
    const cachedResponse = this.travelDocsErrorsSubject.value;
    if (cachedResponse) {
      return of(cachedResponse);
    }

    return this.timaticErrorsService.getTravelDocsErrors().pipe(
      tap((response) => {
        this.travelDocsErrorsSubject.next(response);
      }),
      catchError(() => of(null))
    );
  }

  get travelDocsErrors$(): Observable<TravelDocsErrors | null> {
    return this.travelDocsErrorsSubject.asObservable();
  }

  get hasData(): boolean {
    return this.travelDocsErrorsSubject.value !== null;
  }
}
